/* dashboard-rediseno (15-oct-2026): LA TARJETA PARA AGREGAR MATERIAL (con documentos).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Fondo #141414, borde #222222, radio 18, relleno 14. El campo de YouTube con "Import" adentro,
   "or" y el boton "Upload PDF or photo" (fondo #1B1B1B, borde #2C2C2C); debajo, en 13 px, "Up to
   50K characters per document". En el telefono todo va en un renglon: el campo a 16 px sin el
   icono de video, "Import" adentro y "Upload" como icono de 52 x 52; "or" y el texto de 50K se
   ocultan.

   D3 (limite de documentos): el campo, "Import" y "Upload" al 45 % y el texto de abajo cambia a
   candado y "Delete documents to upload more, or upgrade your plan" (el de hoy), tambien en el
   telefono. F2 (subiendo): debajo de una linea, un renglon de 48 px por archivo. Lo que hace cada
   control es lo de hoy: lo pasa el Panel. */
import React from 'react';
import { Check, Clock, FileText, Loader2, Lock, Upload, X } from 'lucide-react';
import CampoDeYoutube from './CampoDeYoutube';

export const TARJETA_PARA_AGREGAR = 'rounded-[18px] border border-[#222222] bg-[#141414] p-3.5';

function RenglonDeSubida({ item, t }) {
  return (
    <div className="min-h-12 flex items-center gap-3 py-1.5">
      <FileText className="w-4 h-4 text-[#9A9A9A] shrink-0" aria-hidden="true" />
      <div className="flex-1 min-w-0">
        <p className="text-[13px] leading-[18px] text-[#F4F4F3] truncate">{item.name}</p>
        {item.status === 'error' && item.error ? <p className="text-[12px] leading-4 text-[#F87171] break-words">{item.error}</p> : null}
        {item.status === 'pending' ? (
          <p className="text-[12px] leading-4 text-[#9A9A9A] flex items-center gap-1"><Clock className="w-3 h-3" aria-hidden="true" />{t('dashboard:upload_queue.waiting_for_credits')}</p>
        ) : null}
      </div>
      <div className="shrink-0 flex items-center gap-1.5 text-[12px] font-semibold tabular-nums">
        {item.status === 'uploading' || item.status === 'queued' ? (
          <><Loader2 className="w-4 h-4 text-[#D4D4D4] animate-spin" aria-hidden="true" /><span className="text-[#D4D4D4]">{item.progress}%</span></>
        ) : item.status === 'error' ? (
          <X className="w-4 h-4 text-[#F87171]" aria-hidden="true" />
        ) : item.status === 'done' ? (
          <Check className="w-4 h-4 text-[#4ADE80]" aria-hidden="true" />
        ) : null}
      </div>
    </div>
  );
}

// estilos-1 (Bloque C, 4.1): `estilo` es la pastilla del estilo de examen (solo con la perilla encendida). Va debajo
// del campo y del boton, a la izquierda, y con ella el renglon de 50K se va de la tarjeta. Sin `estilo`, la de hoy.
export default function TarjetaParaAgregar({
  t, campo, subida, cola = [], estilo = null,
}) {
  const { apagado, alSubir, inputRef, alTocarConTope, tituloDeSubida, subiendo, accept, porTope } = subida;
  return (
    <div className={TARJETA_PARA_AGREGAR} data-testid="tarjeta-agregar">
      <div className="flex items-start gap-2 md:gap-3">
        <CampoDeYoutube t={t} {...campo} />
        <span className="hidden md:inline-flex h-11 items-center text-[13px] text-[#6A6A6A] shrink-0">{t('dashboard:panel.o')}</span>
        <label title={tituloDeSubida} className="shrink-0"
          onClick={(e) => { if (alTocarConTope && alTocarConTope()) e.preventDefault(); }}>
          <input ref={inputRef} type="file" className="hidden" accept={accept} multiple onChange={alSubir}
            disabled={apagado} data-testid="upload-input" />
          <span
            className={`relative inline-flex items-center justify-center gap-2 h-[52px] w-[52px] md:w-auto md:h-11 md:px-4 rounded-[14px] bg-[#1B1B1B] border border-[#2C2C2C] text-[#F4F4F3] text-[14px] font-semibold cursor-pointer ${apagado ? 'opacity-45 cursor-not-allowed' : 'hoverable:bg-[#232323] active:bg-[#232323] active:duration-0'}`}
            aria-label={t('dashboard:panel.subir_pdf_foto')}
            data-testid="upload-btn"
          >
            {subiendo ? <Loader2 className="w-4 h-4 animate-spin" aria-hidden="true" /> : <Upload className="w-4 h-4" aria-hidden="true" />}
            <span className="hidden md:inline">{t('dashboard:panel.subir_pdf_foto')}</span>
          </span>
        </label>
      </div>
      {estilo ? <div className="mt-2 flex min-w-0" data-testid="estilo-fila">{estilo}</div> : null}
      {porTope ? (
        <p className="mt-2 text-[13px] leading-[18px] text-[#9A9A9A] flex items-center gap-1.5" data-testid="upload-bloqueado">
          <Lock className="w-3.5 h-3.5 shrink-0" aria-hidden="true" />{t('dashboard:header.upload_blocked_tooltip')}
        </p>
      ) : estilo ? null : (
        <p className="hidden md:block mt-2 text-[13px] leading-[18px] text-[#6A6A6A]" data-testid="char-limit">{t('dashboard:panel.hasta_50k')}</p>
      )}
      {cola.length > 0 ? (
        <div className="mt-3 pt-1.5 border-t border-[#222222]" data-testid="upload-queue">
          {cola.map((item) => <RenglonDeSubida key={item.id} item={item} t={t} />)}
        </div>
      ) : null}
    </div>
  );
}
